import { setDownloadLoad, setPrintLoad } from '@/redux/SRP/srpSlice.js';
import { baseApi } from './apiConfig.js';

export const getSRPFilter = async url => {
    try {
        const response = await baseApi.get(`/near-me?${url ? url : ''}`);
        const { status, data } = response;
        if (status === 200) {
            return data?.data;
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP Filter error', error);
    }
};
export const getStateList = async () => {
    try {
        const response = await baseApi.get('/portal/search/states');
        const { status, data } = response?.data;
        if (status === 'SUCCESS') {
            return data;
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP State list error', error);
    }
};

// export const getSRPDownload = async (param, dispatch) => {
//     try {
//         const fileName =
//             param.searchBy?.trim() ? param.searchBy :
//             param.zip?.trim() ? param.zip :
//             param.state?.trim() ? param.state :"SRP";
//         const response = await baseApi.post('/portal/downloadSRPDetails', param);
//         const { status, data } = response;
//         if (status === 200) {
//             const url = window.URL.createObjectURL(new Blob([data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'Hubzu_' + fileName + '.xls');
//             document.body.appendChild(link);
//             link.click();
//         } else {
//             throw response
//         }
//     } catch (error) {
//         console.error('SRP download error', error);
//     } finally {
//         dispatch(setSRPInitialLoad(false));
//     }
// };


export const getSRPDownload = async (param, dispatch) => {
    try {
        const fileName =
            param.searchBy?.trim() ? param.searchBy :
            param.zip?.trim() ? param.zip :
            param.state?.trim() ? param.state :"SRP";
        
        const response = await baseApi.post('/portal/downloadSRPDetails', param, {
            responseType: 'blob'
        });
        
        const { status, data } = response;
        if (status === 200) {
            // The server may return a JSON error payload disguised as a blob
            try {
                const text = await data.text();
                const json = JSON.parse(text);
                if (json?.status === 'FAILED') {
                    const { toast } = await import('react-toastify');
                    toast.error(json.message || 'Export failed. Please try again.');
                    return;
                }
            } catch {
                // Not JSON — treat as a valid file blob and proceed
            }

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Hubzu_' + fileName + '.xls');
            document.body.appendChild(link);
            link.click();
        } else {
            throw response
        }
    } catch (error) {
        const { toast } = await import('react-toastify');
        // When responseType is 'blob', Axios puts the error body in error.response.data as a Blob
        try {
            const errBlob = error?.response?.data;
            if (errBlob instanceof Blob) {
                const text = await errBlob.text();
                // Try valid JSON first, then fall back to single-quoted format
                let message;
                try {
                    const json = JSON.parse(text);
                    message = json?.message;
                } catch {
                    const match = text.match(/'message'\s*:\s*'([^']+)'/);
                    message = match?.[1];
                }
                if (message) {
                    toast.error(message);
                    return;
                }
            }
        } catch (parseError) {
            console.error('SRP download error — failed to parse error response:', parseError);
        }
        toast.error('Export failed. Please try again.');
    } finally {
        dispatch(setDownloadLoad(false));
    }
};


export const getSRPPrint = async (param, dispatch) => {
    try {
        const response = await baseApi.post('/portal/printSRPDetails', param, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        });
        const { status, data } = response;
        // show pdf in new tab 
        if (status === 200) {
            const blob = new Blob([data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(() => window.URL.revokeObjectURL(url), 10000);
        } else {
            throw response;
        }

    } catch (error) {
        console.error('SRP display error', error);
    } finally {
        dispatch(setPrintLoad(false));
    }
};

// export const getSRPPrint = async (param) => {
//     try {
//         const response = await baseApi.post('/portal/printSRPDetails', param, {
//             responseType: 'arraybuffer',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/pdf'
//             }});
//         const {status, data} = response;
//         if (status === 200) {
//             const url = window.URL.createObjectURL(new Blob([data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'Hubzu_SRP.pdf');
//             document.body.appendChild(link);
//             link.click();
//         } else {
//             throw response
//         }
//     } catch (error) {
//         console.error('SRP download error', error);
//     }
// };

export const onSavePress = async ({ propertyId }) => {
    try {
        const response = await baseApi.post(`/portal/watchProperty/${propertyId}?notifyType=DAILY`);
        const { status } = response;
        if (status === 200) {
            return 'success';
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP Save error', error);
    }
};

export const onUnsavePress = async ({ propertyId }) => {
    try {
        const response = await baseApi.post(`/portal/drawer/deleteSavedProperty`, { propertyId });
        const { status } = response;
        if (status === 200) {
            return 'success';
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP Unsave error', error);
    }
};

export const fetchAllUsStates = async () => {
    try {
        const response = await baseApi.get('/portal/site-map');
        if (response?.data.data) {
            return response?.data.data.states;
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP State list error', error);
    }
};
export const fetchCitiesForState = async ({ state }) => {
    try {
        const response = await baseApi.get(`/portal/state/${state}`);
       if (response?.data.data) {
            return response?.data.data.cities;
        } else {
            throw response
        }
    } catch (error) {
        console.error('SRP State list error', error);
    }
};
